import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createToConnectionRequestModel } from './toConnectionRequestModel';
import { createBasketModel } from './basketModel';

export const useKoobStore = create(
  devtools(
    (...args) => ({
      ...createToConnectionRequestModel(...args),
      ...createBasketModel(...args),
    }),
    { name: 'KoobStore' },
  ),
);
